import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { ToggleSwitch } from '.';
import { toggleSwitchDriverFactory } from './ToggleSwitch.driver';

describe('ToggleSwitch', () => {
  const createDriver = createRendererWithUniDriver(toggleSwitchDriverFactory);

  it('should be checked', async () => {
    const { driver } = createDriver(<ToggleSwitch checked />);

    expect(await driver.isChecked()).toBeTruthy();
  });

  it('should be disabled', async () => {
    const { driver } = createDriver(<ToggleSwitch disabled />);

    expect(await driver.isDisabled()).toBeTruthy();
  });
});
